/** Relationships the revision selector and the correction views need eagerly. */
export const REVISION_RELATIONSHIPS = [
  "creator",
  "groups",
  "applicantFormAssignment",
  "applicantFormAssignment.applicant",
  "corrections",
  "corrections.creator",
  "corrections.group",
  "corrections.comments",
  "corrections.comments.creator",
  "corrections.fieldCorrections",
  "corrections.fieldCorrections.comments",
  "corrections.fieldCorrections.comments.creator",
  "comments",
  "comments.creator",
  "deniedCorrections",
  "deniedCorrections.creator",
  "deniedCorrections.group",
  "deniedCorrections.comments",
  "deniedCorrections.comments.creator",
];
